// extracted by mini-css-extract-plugin
export var ctaPanel = "CtaPanel--ctaPanel--oTaxz";
export var ctaPanel__link = "CtaPanel--ctaPanel__link--eymFN";
export var ctaPanel__title = "CtaPanel--ctaPanel__title--x66qb";
export var margin = "CtaPanel--margin--fmvN-";
export var tkMyriadProSemiCondensed = "CtaPanel--tk-myriad-pro-semi-condensed--R+m9b";